module.exports = __webpack_public_path__ + "img/search.07137af6.svg";